
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'embedded-viral-link-ui',
  currentProjectVersion: 'static-1.6626',
  depVersions: {
  "embedded-viral-link-ui": "static-1.6626",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8225",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11676",
  "I18n": "static-7.1650",
  "jasmine-runner": "static-1.6656",
  "quartz": "static-1.7298",
  "quartz-core": "static-1.6517",
  "react-dlb": "static-1.83",
  "reselect": "static-3.8",
  "webpack-env": "static-1.54",
  "cssUtils": "static-1.851",
  "enviro": "static-4.455",
  "foundations-components": "static-1.8309",
  "hub-http": "static-1.6418",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11983",
  "icons": "static-2.668",
  "immer": "static-1.33",
  "laboratory-lib": "static-3.7353",
  "PortalIdParser": "static-2.404",
  "quartz-config": "static-1.1076",
  "quartz-routing": "static-1.728",
  "quick-fetch": "static-1.4058",
  "react": "static-7.189",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16905",
  "react-select-plus": "static-1.108",
  "react-utils": "static-2.5482",
  "react-virtualized": "static-2.102",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "signup-constants": "static-1.19368",
  "signup-ui-lego-core": "static-1.21378",
  "styled-components": "static-2.89",
  "StyleGuideUI": "static-3.491",
  "ui-addon-react-router-dom": "static-1.9734",
  "ui-images": "static-2.1212",
  "UIComponents": "static-3.8622",
  "usage-tracker": "static-1-session-replay-endpoint-migration.5",
  "usage-tracker-core": "static-1-session-replay-endpoint-migration.5",
  "viral-links-lib": "static-1.7272",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "bend-plugin-trellis-migration": "static-1.3540",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3575",
  "quartz-webpack": "static-1.3522",
  "bend-plugin-quartz-routing": "static-1.376",
  "HeadJS": "static-2.781",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3336",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "foundations-theming": "static-1.4643",
  "i18n-data": "static-1.225",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4525",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.858",
  "hubspotter-http": "static-1.4792",
  "mobile-manifest-mixins": "static-1.555",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.973",
  "quartz-head": "static-1.963",
  "quartz-i18n": "static-1.973",
  "quartz-test": "static-1.973",
  "quartz-tracking": "static-1.677",
  "trellis-components": "static-1.2353",
  "ui-fonts": "static-1.938",
  "usage-tracker-container": "static-1-session-replay-endpoint-migration.5",
  "sassPrefix": "static-1.160",
  "bend-plugin-foundations-components": "static-1.4578",
  "floating-ui": "static-1.60",
  "foundations-assets": "static-1.5076",
  "foundations-theming-specialty": "static-1.2359",
  "hs-story-utils": "static-1.9627",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.50",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2334",
  "hs-locale-management": "static-1.222",
  "superstore": "static-1.4959",
  "csstype": "static-1.50",
  "web-vitals": "static-1.9",
  "rpc-client-utils": "static-1.4859",
  "emoji-regex": "static-1.7",
  "PatternValidationJS": "static-1-add-latest-to-version-tag.2",
  "signup-ui-url-generator": "static-2.8258",
  "bender-build-tools": "static-1.3322",
  "bend-plugin-foundations-theming": "static-1.3126",
  "foundations-theming-base": "static-1.3628",
  "stylex": "static-1.37",
  "hub-http-shared-msw-handlers": "static-1.10442",
  "hubspotter-http-shared-msw-handlers": "static-1.10440",
  "usage-tracker-session-replay": "static-1-session-replay-endpoint-migration.5",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1153",
  "tanstack-virtual": "static-1.33",
  "bend-plugin-chirp-manifest": "static-1.269",
  "chirp-fetch": "static-1.2088",
  "amplitude-session-replay-browser": "static-1.60",
  "ts-schema": "static-1.4220"
},
  depPathPrefixes: {
  "embedded-viral-link-ui": "/embedded-viral-link-ui/static-1.6626",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8225",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11676",
  "I18n": "/I18n/static-7.1650",
  "jasmine-runner": "/jasmine-runner/static-1.6656",
  "quartz": "/quartz/static-1.7298",
  "quartz-core": "/quartz-core/static-1.6517",
  "react-dlb": "/react-dlb/static-1.83",
  "reselect": "/reselect/static-3.8",
  "webpack-env": "/webpack-env/static-1.54",
  "cssUtils": "/cssUtils/static-1.851",
  "enviro": "/enviro/static-4.455",
  "foundations-components": "/foundations-components/static-1.8309",
  "hub-http": "/hub-http/static-1.6418",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11983",
  "icons": "/icons/static-2.668",
  "immer": "/immer/static-1.33",
  "laboratory-lib": "/laboratory-lib/static-3.7353",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "quartz-config": "/quartz-config/static-1.1076",
  "quartz-routing": "/quartz-routing/static-1.728",
  "quick-fetch": "/quick-fetch/static-1.4058",
  "react": "/react/static-7.189",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16905",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-utils": "/react-utils/static-2.5482",
  "react-virtualized": "/react-virtualized/static-2.102",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "signup-constants": "/signup-constants/static-1.19368",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.21378",
  "styled-components": "/styled-components/static-2.89",
  "StyleGuideUI": "/StyleGuideUI/static-3.491",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9734",
  "ui-images": "/ui-images/static-2.1212",
  "UIComponents": "/UIComponents/static-3.8622",
  "usage-tracker": "/usage-tracker/static-1-session-replay-endpoint-migration.5",
  "usage-tracker-core": "/usage-tracker-core/static-1-session-replay-endpoint-migration.5",
  "viral-links-lib": "/viral-links-lib/static-1.7272",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3540",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3575",
  "quartz-webpack": "/quartz-webpack/static-1.3522",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.376",
  "HeadJS": "/HeadJS/static-2.781",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3336",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "foundations-theming": "/foundations-theming/static-1.4643",
  "i18n-data": "/i18n-data/static-1.225",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4525",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.858",
  "hubspotter-http": "/hubspotter-http/static-1.4792",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.555",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.973",
  "quartz-head": "/quartz-head/static-1.963",
  "quartz-i18n": "/quartz-i18n/static-1.973",
  "quartz-test": "/quartz-test/static-1.973",
  "quartz-tracking": "/quartz-tracking/static-1.677",
  "trellis-components": "/trellis-components/static-1.2353",
  "ui-fonts": "/ui-fonts/static-1.938",
  "usage-tracker-container": "/usage-tracker-container/static-1-session-replay-endpoint-migration.5",
  "sassPrefix": "/sassPrefix/static-1.160",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4578",
  "floating-ui": "/floating-ui/static-1.60",
  "foundations-assets": "/foundations-assets/static-1.5076",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2359",
  "hs-story-utils": "/hs-story-utils/static-1.9627",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.50",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2334",
  "hs-locale-management": "/hs-locale-management/static-1.222",
  "superstore": "/superstore/static-1.4959",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.9",
  "rpc-client-utils": "/rpc-client-utils/static-1.4859",
  "emoji-regex": "/emoji-regex/static-1.7",
  "PatternValidationJS": "/PatternValidationJS/static-1-add-latest-to-version-tag.2",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8258",
  "bender-build-tools": "/bender-build-tools/static-1.3322",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3126",
  "foundations-theming-base": "/foundations-theming-base/static-1.3628",
  "stylex": "/stylex/static-1.37",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10442",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10440",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1-session-replay-endpoint-migration.5",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1153",
  "tanstack-virtual": "/tanstack-virtual/static-1.33",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.269",
  "chirp-fetch": "/chirp-fetch/static-1.2088",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "ts-schema": "/ts-schema/static-1.4220"
}
};
